<template>
    <Page withNavbar withNavigation>
        <main>
            <section class="video">
                <Player :id="project.id"/>
            </section>
            <section class="infos">
                <div class="text">
                    <h4>{{ project.title }}</h4>
                    <p>{{ project.description }}</p>
                    <p><i>{{ date }}</i></p>
                </div>
                <div class="actions">
                    <ul>
                        <li>
                            <a @click.stop="onShareFacebook">
                                <IconFacebook :color="config.COLOR_PRIMARY"/>
                            </a>
                        </li>
                        <li>
                            <a @click.stop="onShareTwitter">
                                <IconTwitter :color="config.COLOR_PRIMARY"/>
                            </a>
                        </li>
                        <li v-if="project.lastOutput">
                            <a
                                :href="project.lastOutput.url"
                                :download="project.lastOutput.filename"
                                target="_blank"
                                @click="(e) => e.stopPropagation()"
                            >
                                <IconDownload :color="config.COLOR_PRIMARY"/>
                            </a>
                        </li>
                    </ul>
                </div>
            </section>
            <section class="projects">
                <ProjectsList :projects="otherProjects" @click="onProjectClick"/>
            </section>
        </main>
    </page>
</template>
<script>
import {
    SocialConsumer, SolutionConsumer, UserConsumer, ProjectConsumer,
} from '../../mixins';
import { Page } from '../../components/mobile';
import { Player, ProjectsList } from '../../components/shared';

export default {
    name: 'Project',
    components: {
        Page, ProjectsList, Player,
    },
    mixins: [SocialConsumer, SolutionConsumer, UserConsumer, ProjectConsumer],
    props: {
        projectID: {
            type: String,
            default: null,
        },
    },
    data () {
        return {
            project: null,
        };
    },
    computed: {
        otherProjects () {
            return this.validatedProjects ? this.validatedProjects.filter((project) => project.id !== this.project.id) : null;
        },
        date () {
            return new Date(this.project.createdAt * 1000).toLocaleDateString();
        },
    },
    beforeRouteUpdate (to, from, next) {
        this.update(to.params.projectID);
        next();
    },
    created () {
        this.update(this.projectID);
    },
    methods: {
        onShareFacebook () {
            this.shareFacebook(this.getPlayerFrontURL(this.project.id));
        },
        onShareTwitter () {
            this.shareTwitter(this.getPlayerFrontURL(this.project.id));
        },
        onProjectClick (project) {
            this.$router.push({ name: 'project', params: { projectID: project.id } });
        },
        update (id) {
            try {
                this.project = this.projects.find((project) => project.id === id);
            } catch (err) {
                console.error(err);
            }
        },
    },
};
</script>
<style lang="scss" scoped>
@import '../../assets/scss/colors';
@import '../../assets/scss/mixins';

main {
    margin-top: 66px;

    > .infos {
        @include container(20px);
        display: flex;
        flex-direction: column;
        background-color: $white;

        > .actions {
            place-self: flex-end;

            > ul {
                @include ul-horizontal(10px);

                > li {
                    &:hover {
                        filter: brightness(1.1);
                    }

                    > a {
                        @include a-reset();
                        cursor: pointer;

                        > svg {
                            @include square(16px);
                        }
                    }
                }
            }
        }
    }

    > .projects {
        @include container(20px);
    }
}
</style>
